import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/tag-matching')({
    component: TagMatchingPage,
});

function TagMatchingPage() {
    return <Navigate to="/settings/tags" replace={true} />;
}
